import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-activity-form',
  templateUrl: './activity-form.component.html',
  styleUrls: ['./activity-form.component.scss'],
})
export class ActivityFormComponent implements OnInit {

  constructor(
    private modalCtrl: ModalController
  ) { }

  ngOnInit() { }

  activity = {
    id: '',
    name: '',
    duration: null,
    notes: ''
  }


  save() {
    this.modalCtrl.dismiss(this.activity)
  }

  close(){
    this.modalCtrl.dismiss()
  }
}
